// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodeSandboxCircleFilledSvg from "@ant-design/icons-svg/es/asn/CodeSandboxCircleFilled";
import AntdIcon from '../components/AntdIcon';

var CodeSandboxCircleFilled = function CodeSandboxCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodeSandboxCircleFilledSvg
  }));
};

CodeSandboxCircleFilled.displayName = 'CodeSandboxCircleFilled';
export default React.forwardRef(CodeSandboxCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CodeSandboxCircleFilled.js
// module id = 817
// module chunks = 0